interface IENV {
  REACT_APP_MEDIUM_API: string;
  REACT_APP_PORTFOLIO_API: string;
  REACT_APP_SENTRY_PROJECT: string;
  REACT_APP_EMAILJS_PUBLIC_KEY: string;
  REACT_APP_EMAILJS_SERVICE_ID: string;
  REACT_APP_EMAILJS_TEMPLATE_ID: string;
  REACT_APP_PORTFOLIO_V1: string;
}

export const env: IENV = {
  REACT_APP_MEDIUM_API: process.env.REACT_APP_MEDIUM_API as string,
  REACT_APP_PORTFOLIO_API: process.env.REACT_APP_PORTFOLIO_API as string,
  REACT_APP_SENTRY_PROJECT: process.env.REACT_APP_SENTRY_PROJECT as string,
  REACT_APP_EMAILJS_PUBLIC_KEY: process.env
    .REACT_APP_EMAILJS_PUBLIC_KEY as string,
  REACT_APP_EMAILJS_SERVICE_ID: process.env
    .REACT_APP_EMAILJS_SERVICE_ID as string,
  REACT_APP_EMAILJS_TEMPLATE_ID: process.env
    .REACT_APP_EMAILJS_TEMPLATE_ID as string,
  REACT_APP_PORTFOLIO_V1: process.env.REACT_APP_PORTFOLIO_V1 as string,
};
